import React from "react";
import { formatMoney } from "accounting-js";
import {
  distributedPayout,
  msaTotalCFAInstallment,
  msaTotalCfaInstallmentIncPayout
} from "../redux/selectors";
import { connect } from "react-redux";
import style from "./HardwareExtraOptions.module.css";
import { isCfaRentOrLease } from "../redux/selectors";
import {IS_NZ} from "../constants";
import { isPPPOrPMP } from "../redux/selectors";

function renderNonMsaCharges(isPPPOrPMP, {
  ccBw,
  ccColour,
  scanCharge,
  scanningMonthlyCharge,
  flatMonthlyCharge,
  minimumMonthlyCharge,
  nzScanningMonthlyCharge,
  perA3Charge,
  perA3ChargeObject,
  tonerDeliveryCharge
}) {
  return (
    <>
      {ccBw ||
      ccColour ||
      scanCharge ||
      scanningMonthlyCharge ||
      flatMonthlyCharge ? (
        <dt className="col-sm-12">Charges</dt>
      ) : null}
      {ccBw ? (
        <>
          <dd className="col-sm-4">Click Charge B&amp;W</dd>
          <dd className="col-sm-8">{ccBw}¢</dd>
        </>
      ) : null}
      {ccColour ? (
        <>
          <dd className="col-sm-4">Click Charge Colour</dd>
          <dd className="col-sm-8">{ccColour}¢</dd>
        </>
      ) : null}
      {scanCharge ? (
        <>
          <dd className="col-sm-4">Scan Charge</dd>
          <dd className="col-sm-8">{scanCharge}¢</dd>
        </>
      ) : null}

      {!IS_NZ && scanningMonthlyCharge ? (
        <>
          <dd className="col-sm-4">Scanning Monthly Charge</dd>
          <dd className="col-sm-8">{formatMoney(scanningMonthlyCharge)}</dd>
        </>
      ) : null}
      {(flatMonthlyCharge && !isPPPOrPMP) ? (
        <>
          <dd className="col-sm-4">Flat Monthly Charge</dd>
          <dl>{formatMoney(flatMonthlyCharge)}</dl>
        </>
      ) : null}
      {IS_NZ && 
      (
        minimumMonthlyCharge || 
        nzScanningMonthlyCharge ||
        perA3Charge ||
        tonerDeliveryCharge
      ) ?
      <dt className="col-sm-12">Other Charges</dt>
      : null
      }
      {IS_NZ && minimumMonthlyCharge ? (
        <>
          <dd className="col-sm-4">Minimum Monthly Charge</dd>
          <dd className="col-sm-8">{formatMoney(minimumMonthlyCharge)}</dd>
        </>
      ) : null}
      {IS_NZ && nzScanningMonthlyCharge ? (
        <>
          <dd className="col-sm-4">Scanning Monthly Charge</dd>
          <dd className="col-sm-8">{formatMoney(nzScanningMonthlyCharge)}</dd>
        </>
      ) : null}
      {IS_NZ && perA3Charge ? (
        <>
          <dd className="col-sm-4">Per A3 Charge</dd>
          <dd className="col-sm-8">{perA3ChargeObject[perA3Charge]}</dd>
        </>
      ) : null}
      {IS_NZ && tonerDeliveryCharge ? (
        <>
          <dd className="col-sm-4">Toner Delivery Charge</dd>
          <dd className="col-sm-8">{formatMoney(tonerDeliveryCharge)}</dd>
        </>
      ) : null}
    </>
  );
}

function renderMsaCharges({
  msaMetroClickChargeBw,
  msaMetroClickChargeColour,
  msaRegionalClickChargeBw,
  msaRegionalClickChargeColour
}) {
  return (
    <>
      <dt className="col-sm-12">Click Charge</dt>

      <dd className="col-sm-4">Metro B&amp;W</dd>
      <dd className="col-sm-8">
        {" "}
        {msaMetroClickChargeBw ? `${msaMetroClickChargeBw}¢` : "N/A"}
      </dd>

      <dd className="col-sm-4">Metro Colour</dd>
      <dd className="col-sm-8">
        {msaMetroClickChargeColour ? `${msaMetroClickChargeColour}¢` : "N/A"}
      </dd>

      <dd className="col-sm-4">Regional B&amp;W</dd>
      <dd className="col-sm-8">
        {" "}
        {msaRegionalClickChargeBw ? `${msaRegionalClickChargeBw}¢` : "N/A"}
      </dd>

      <dd className="col-sm-4">Regional Colour</dd>
      <dd className="col-sm-8">
        {msaRegionalClickChargeColour
          ? `${msaRegionalClickChargeColour}¢`
          : "N/A"}
      </dd>
    </>
  );
}

function HardwareExtraOptions({
  isPPPOrPMP,
  isMsa,
  item,
  isCfaRentOrLease,
  distributedPayout,
  msaTotalCfaInstallmentIncPayout,
  msaTotalCFAInstallment
}) {
  return (
    <dl className={`row ${style.root}`}>
      {(isMsa ? renderMsaCharges : renderNonMsaCharges)(isPPPOrPMP, item)}

      {item.underWarranty ? (
        <>
          <dt className="col-sm-4">Warranty</dt>
          <dd className="col-sm-8">Yes</dd>
        </>
      ) : null}

      {item.subscriptionTargetChargeValue &&
      item.subscriptionUserNum &&
      item.subscriptionTerm ? (
        <>
          <dt className="col-sm-4">Subscription</dt>
          <dd className="col-sm-8">
            ${item.subscriptionTargetChargeValue}
            &nbsp; per user for &nbsp;
            {item.subscriptionUserNum}
            &nbsp;users per month for &nbsp;
            {item.subscriptionTerm}
            &nbsp; months
          </dd>
        </>
      ) : null}

      {item.ccCampaigns && item.ccCampaigns.length ? (
        <>
          <dt className="col-sm-4">Campaigns</dt>
          <dd className="col-sm-8">{item.ccCampaigns.join(", ")}</dd>
        </>
      ) : null}

      {isCfaRentOrLease && (item.msaDefaultTerm || item.msaTerm) ? (
        <>
          <dt className="col-sm-12">Term</dt>
        </>
      ) : null}

      {isCfaRentOrLease && item.msaDefaultTerm ? (
        <>
          <dd className="col-sm-4">Default</dd>
          <dd className="col-sm-8">{item.msaDefaultTerm}</dd>
        </>
      ) : null}

      {isCfaRentOrLease && item.msaTerm ? (
        <>
          <dd className="col-sm-4">Target</dd>
          <dd className="col-sm-8">{item.msaTerm}</dd>
        </>
      ) : null}

      {isCfaRentOrLease && (item.msaDefaultCfa || item.msaCfa) ? (
        <>
          <dt className="col-sm-12">CF Cost per Thousand</dt>
        </>
      ) : null}

      {isCfaRentOrLease && item.msaDefaultCfa ? (
        <>
          <dd className="col-sm-4">Default</dd>
          <dd className="col-sm-8">
            {formatMoney(Number(item.msaDefaultCfa))}
          </dd>
        </>
      ) : null}

      {isCfaRentOrLease && item.msaCfa ? (
        <>
          <dd className="col-sm-4">Target</dd>
          <dd className="col-sm-8">{formatMoney(Number(item.msaCfa))}</dd>
        </>
      ) : null}

      {item.msaDefaultMdsCost || item.msaMdsCost ? (
        <>
          <dt className="col-sm-12">MDS Cost</dt>
        </>
      ) : null}

      {item.msaDefaultMdsCost ? (
        <>
          <dd className="col-sm-4">Default</dd>
          <dd className="col-sm-8">
            {formatMoney(Number(item.msaDefaultMdsCost))}
          </dd>
        </>
      ) : null}

      {item.msaMdsCost ? (
        <>
          <dd className="col-sm-4">Target</dd>
          <dd className="col-sm-8">{formatMoney(Number(item.msaMdsCost))}</dd>
        </>
      ) : null}

      {isCfaRentOrLease && item.msaCfa ? (
        <>
          <dt className="col-sm-12">Total CF Installment</dt>

          <dd className="col-sm-4">Product Only (Each)</dd>
          <dd className="col-sm-8">
            {formatMoney(item.targetPrice)} × {Number(item.msaCfa).toFixed(2)} ÷
            1000 = {formatMoney(msaTotalCFAInstallment)}
          </dd>

          <dd className="col-sm-4">inc Payout (Each)</dd>
          <dd className="col-sm-8">
            ({formatMoney(item.targetPrice)} + {formatMoney(distributedPayout)})
            × {item.msaCfa} ÷ 1000 ={" "}
            {formatMoney(msaTotalCfaInstallmentIncPayout)}
            &nbsp;
            <small className="text-danger">
              (Updated when the "Total Payout" is updated in the "Finance"
              section)
            </small>
          </dd>

          <dd className="col-sm-4">inc Payout (Per Line)</dd>
          <dd className="col-sm-8">
            {formatMoney(msaTotalCfaInstallmentIncPayout)} × {item.qty} ={" "}
            {formatMoney(msaTotalCfaInstallmentIncPayout * item.qty)}
          </dd>
        </>
      ) : null}

      {item.msaPriceFlag ||
      (isCfaRentOrLease &&
        (item.msaPayableMethod || item.msaInstalmentFrequency)) ? (
        <>
          <dt className="col-sm-12">Other CF Details</dt>
        </>
      ) : null}

      {item.msaPriceFlag ? (
        <>
          <dd className="col-sm-4">MSA Price Flag</dd>
          <dd className="col-sm-8">{item.msaPriceFlag === 'CPQ_N/A' ? 'Not Applicable' : item.msaPriceFlag}</dd>
        </>
      ) : null}

      {isCfaRentOrLease && item.msaPayableMethod ? (
        <>
          <dd className="col-sm-4">Payable Method</dd>
          <dd className="col-sm-8">{item.msaPayableMethod}</dd>
        </>
      ) : null}

      {isCfaRentOrLease && item.msaInstalmentFrequency ? (
        <>
          <dd className="col-sm-4">Instalment Frequency</dd>
          <dd className="col-sm-8">{item.msaInstalmentFrequency}</dd>
        </>
      ) : null}
    </dl>
  );
}

export default connect((state, { item }) => ({
  isPPPOrPMP: isPPPOrPMP(state),
  isMsa: state.quote.isMsa,
  isCfaRentOrLease: isCfaRentOrLease(state),
  distributedPayout: distributedPayout(state, item.targetPrice),
  msaTotalCFAInstallment: msaTotalCFAInstallment(item.targetPrice, item.msaCfa),
  msaTotalCfaInstallmentIncPayout: msaTotalCfaInstallmentIncPayout(
    state,
    item.targetPrice,
    item.msaCfa
  )
}))(HardwareExtraOptions);
